import { EventEmitter } from 'events'

export const cartEmitter = new EventEmitter()
